import { memo } from 'react'
import { Box, Stack, Typography, CircularProgress } from '@mui/material'
import { fmtAmount } from './formatters'

const summaryCardSx = {
  flex: 1,
  borderRadius: 2,
  px: 2,
  py: 1.75,
  minHeight: 76,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: '0 2px 4px -1px rgba(0,0,0,0.06), 0 4px 6px -1px rgba(0,0,0,0.1)',
}

function SummaryCards({ totalSales, totalInvoices, loading }) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
      <Box
        sx={{
          ...summaryCardSx,
          background: 'linear-gradient(180deg, #FFFFFF 0%, #F4ECFF 100%)',
        }}
      >
        {loading ? (
          <CircularProgress size={22} sx={{ color: '#6941C6' }} />
        ) : (
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#25314C', mb: 0.5 }}>
            {fmtAmount(totalSales)}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          Total sales
        </Typography>
      </Box>
      <Box
        sx={{
          ...summaryCardSx,
          background: 'linear-gradient(180deg, #FFFFFF 0%, #E8F4FC 100%)',
        }}
      >
        {loading ? (
          <CircularProgress size={22} sx={{ color: '#11809A' }} />
        ) : (
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#25314C', mb: 0.5 }}>
            {totalInvoices}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          Total invoices
        </Typography>
      </Box>
    </Stack>
  )
}

export default memo(SummaryCards)
